var $c3cc19a9c5ad2d83$exports = {};
$c3cc19a9c5ad2d83$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farvev\xe6lger`,
    "colorSwatch": `farvepr\xf8ve`,
    "transparent": `gennemsigtig`,
    "twoDimensionalSlider": `2D-skyder`
};


export {$c3cc19a9c5ad2d83$exports as default};
//# sourceMappingURL=da-DK.mjs.map
